/**
 * @format
 * @module ui-header-accordion
 */

import { API_PB_RENDER_FEATURE } from "lib/gamservices";
import logger from "utils/logger";
import { qs, qsa } from "utils/utils";

import AccordionPrototype from "ui/accordion";
import { validStatus, handleJSON, handleRenderFeature } from "utils/fetch";

const debugTag = "[HEADER-ACCORDION]";

export let loaded = false;

export function load() {
  const placeholder = document.querySelector(".js-c-accordion-placeholder");
  if (!placeholder) {
    logger.info(`${debugTag} aborting because no placeholder was found`);
    return;
  }
  const skeleton = placeholder.querySelector(".c-accordion--skeleton");
  const contentConfig = encodeURIComponent('{"hierarchy":"web-nav"}'); // eslint-disable-line quotes
  const pbRenderAPI = `${API_PB_RENDER_FEATURE}/global/header-accordion?contentConfig=${contentConfig}&service=sites-by-hierarchy`;
  fetch(pbRenderAPI)
    .then(validStatus)
    .then(handleJSON)
    .then(handleRenderFeature)
    .then(markup => {
      const container = document.createElement("div");
      container.innerHTML = markup;
      placeholder.appendChild(container);

      skeleton.addEventListener("transitionend", () => {
        skeleton.parentNode.removeChild(skeleton);
      });
      skeleton.classList.add("c-accordion--skeleton--hiding");
      loaded = true;
      init(placeholder);
    })
    .catch(() => {
      logger.info(`${debugTag} content failed to load`);
    });
}

function init(placeholder) {
  const accordion = Object.create(AccordionPrototype);
  if (accordion) {
    accordion.init(placeholder.querySelector(".c-accordion:not(.c-accordion--skeleton)"));
  } else {
    logger.info(`${debugTag} unable to initialize`);
  }

  const readerServices = qs(".js-reader-services");
  if (!readerServices) {
    return;
  }
  const readerServicesItems = qsa(".c-accordion__item", readerServices).filter(
    l => !l.classList.contains("u-hidden")
  );
  readerServicesItems.forEach((i, index) => {
    const link = qs(".c-accordion__item-link", i);
    if (!link) {
      return;
    }
    link.dataset.analyticsclick = JSON.stringify({
      type: "link",
      feature: "panel",
      label: link.innerText.toLowerCase(),
      position: index + 1,
      hierarchy: 1
    });
  });
}
